import { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import styles from "./TabsNavigation.module.css";

const TabsNavigation = ({ onTabSelect, selectedTab }) => {
	const { t } = useTranslation();

	const pages = [t("Play"), t("Leaderboard"), t("Prizes"), t("Betway Account"), t("Rules"), t("T&Cs"), t("Upcoming Matches")];

	// Scroll to the selected tab whenever selectedTab changes
	useEffect(() => {
		const selectedTabElement = document.getElementById(selectedTab);
		if (selectedTabElement) {
			selectedTabElement.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
		}
	}, [selectedTab]);

	const handleTabSelect = (tab) => {
		onTabSelect(tab);
		// The scrolling will be handled by the useEffect above
	};

	return (
		<div className={styles.container}>
			{pages.map((page, index) => (
				<div
					key={index}
					id={index}
					className={[styles.tab, selectedTab === index ? styles.tabSelected : ""].join(" ")}
					onClick={() => handleTabSelect(index)}
				>
					{page}
				</div>
			))}
		</div>
	);
};

export default TabsNavigation;
